var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHumidity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3",
    "data-name": 3,
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 44.897,
    viewBox: "0 0 40 44.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,44.9V16.131L20,0l9,7.259V5.108h4.667v5.915L40,16.131V44.9Z",
    fill: "#e1f4fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(3.056 3.678)",
    fill: "#e1f4fb",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 33.13056182861328 37.9710807800293 L 0.7500008940696716 37.9710807800293 L 0.7500008940696716 13.84062099456787 L 16.94359397888184 0.9584417939186096 L 33.13056182861328 13.84053611755371 L 33.13056182861328 37.9710807800293 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.94350051879883 1.916896820068359 L 1.5 14.20236778259277 L 1.5 37.2210807800293 L 32.38056182861328 37.2210807800293 L 32.38056182861328 14.20219039916992 L 16.94350051879883 1.916896820068359 M 16.94369125366211 3.814697265625e-06 L 33.88056182861328 13.47889137268066 L 33.88056182861328 38.7210807800293 L 0 38.7210807800293 L 0 13.47889137268066 L 16.94369125366211 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "water",
    transform: "translate(8.843 12.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M0,13.546C0,8.5,7.417.5,7.732.165a.575.575,0,0,1,.807,0C8.855.5,16.271,8.5,16.271,13.546c0,5.379-2.889,8.341-8.136,8.341S0,18.925,0,13.546Zm1.085,0c0,3.329,1.223,7.3,7.051,7.3s7.051-3.969,7.051-7.3c0-3.974-5.4-10.371-7.051-12.238C6.481,3.174,1.085,9.572,1.085,13.546ZM7,19.8a5.078,5.078,0,0,1-3.654-1.83C1.615,15.8,2.153,12.556,2.177,12.418A.541.541,0,0,1,2.8,12a.525.525,0,0,1,.448.584c0,.029-.482,2.944.96,4.752a4.027,4.027,0,0,0,2.9,1.422.521.521,0,0,1-.054,1.04Z",
    transform: "translate(0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M0,.838A9.721,9.721,0,0,1,2.973.02C4.738.25,6.866,1.488,7.8,1.419,9.835,1.267,10.5.16,12.324.02a5.721,5.721,0,0,1,3.269.818",
    transform: "translate(6.75 7.818)",
    fill: "none",
    stroke: "#00a3da",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    "data-name": "Line",
    d: "M0,.838A9.721,9.721,0,0,1,2.973.02C4.738.25,6.866,1.488,7.8,1.419,9.835,1.267,10.5.16,12.324.02a5.721,5.721,0,0,1,3.269.818",
    transform: "translate(6.75 10.424)",
    fill: "none",
    stroke: "#00a3da",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-3",
    "data-name": "Line",
    d: "M0,.838A9.721,9.721,0,0,1,2.973.02C4.738.25,6.866,1.488,7.8,1.419,9.835,1.267,10.5.16,12.324.02a5.721,5.721,0,0,1,3.269.818",
    transform: "translate(6.75 13.031)",
    fill: "none",
    stroke: "#00a3da",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.184f848b42ef8087c41e5c4938df6b5e.svg";
export { ForwardRef as ReactComponent };